import React, { Component } from "react";
import PropTypes from "prop-types";
import IdleTimer from "react-idle-timer";
import {
  showPopUp,
  hidePopUp,
  DecrementCountDown
} from "../../actions/globalActions";
import { connect } from "react-redux";

class IdleWrapper extends Component {
  _onAction = e => {
  };

  _onActive = e => {
  };

  _onIdle = e => {
    this.props.showPopUp();
  };

  render() {    
    return (
      <div>
        <IdleTimer
          ref={ref => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this._onActive}
          onIdle={this._onIdle}
          onAction={this._onAction}
          debounce={250}          
          timeout={1000 * 60 * 29}
          // reverted the code for force logout
          // timeout={1000 * 60 * 9}
        />
      </div>
    );
  }
}
IdleWrapper.propTypes = {
  showPopUp: PropTypes.func
};

const mapDispatchToProps = dispatch => {
  return {
    showPopUp: () => dispatch(showPopUp()),
    hidePopUp: () => dispatch(hidePopUp()),
    DecrementCountDown: () => dispatch(DecrementCountDown())
  };
};


export default connect(
  null,
  mapDispatchToProps
)(IdleWrapper);
